export const vsOrButtons = [
    {
        label: "vsUTG", id: "1vs1-vsOR-UTG", myPos: ["HIJ", "CO", "BTN", "SB", "BB"], filters: {
            potType: "Raise",
            lastRaiserPos: "UTG",
            lastRaiseCalls: 0,
            limps: 0
        }
    },
    {
        label: "vsHIJ", id: "1vs1-vsOR-HIJ", myPos: ["CO", "BTN", "SB", "BB"], filters: {
            potType: "Raise",
            lastRaiserPos: "HIJ",
            lastRaiseCalls: 0,
            limps: 0
        }
    },
    {
        label: "vsCO", id: "1vs1-vsOR-CO", myPos: ["BTN", "SB", "BB"], filters: {
            potType: "Raise",
            lastRaiserPos: "CO",
            lastRaiseCalls: 0,
            limps: 0
        }
    },
    {
        label: "vsBTN", id: "1vs1-vsOR-BTN", myPos: ["SB", "BB"], filters: {
            potType: "Raise",
            lastRaiserPos: "BTN",
            lastRaiseCalls: 0,
            limps: 0
        }
    },
    {
        label: "vsSB", id: "1vs1-vsOR-SB", myPos: ["BB"], filters: {
            potType: "Raise",
            lastRaiserPos: "SB",
            lastRaiseCalls: 0,
            limps: 0
        }
    }
];
export const vs3BetButtons = [
    {
        label: "vsHIJ", id: "1vs1-vs3BET-HIJ", myPos: ["UTG"], filters: {
            potType: "3BET",
            lastRaiserPos: "HIJ",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsCO", id: "1vs1-vs3BET-CO", myPos: ["UTG", "HIJ"], filters: {
            potType: "3BET",
            lastRaiserPos: "CO",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsBTN", id: "1vs1-vs3BET-BTN", myPos: ["UTG", "HIJ", "CO"], filters: {
            potType: "3BET",
            lastRaiserPos: "BTN",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsSB", id: "1vs1-vs3BET-SB", myPos: ["UTG", "HIJ", "CO", "BTN"], filters: {
            potType: "3BET",
            lastRaiserPos: "SB",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsBB", id: "1vs1-vs3BET-BB", myPos: ["UTG", "HIJ", "CO", "BTN", "SB"], filters: {
            potType: "3BET",
            lastRaiserPos: "BB",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    }
];
export const vs4BetButtons = [
    {
        label: "vsUTG", id: "1vs1-vs4BET-UTG", myPos: ["HIJ","CO","BTN","SB","BB"], filters: {
            potType: "4BET",
            lastRaiserPos: "UTG",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsHIJ", id: "1vs1-vs4BET-HIJ", myPos: ["CO",'BTN',"SB","BB"], filters: {
            potType: "4BET",
            lastRaiserPos: "HIJ",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsCO", id: "1vs1-vs4BET-CO", myPos: ["BTN","SB","BB"], filters: {
            potType: "4BET",
            lastRaiserPos: "CO",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsBTN", id: "1vs1-vs4BET-BTN", myPos: ["SB","BB"], filters: {
            potType: "4BET",
            lastRaiserPos: "BTN",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsSB", id: "1vs1-vs4BET-SB", myPos: ["BB"], filters: {
            potType: "4BET",
            lastRaiserPos: "SB",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    }
];
export const vs5BetButtons = [
    {
        label: "vsHIJ", id: "1vs1-vs5BET-HIJ", myPos: ["UTG"], filters: {
            potType: "5BET",
            lastRaiserPos: "HIJ",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsCO", id: "1vs1-vs5BET-CO", myPos: ["UTG","HIJ"], filters: {
            potType: "5BET",
            lastRaiserPos: "CO",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsBTN", id: "1vs1-vs5BET-BTN", myPos: ["UTG","HIJ","CO"], filters: {
            potType: "5BET",
            lastRaiserPos: "BTN",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsSB", id: "1vs1-vs5BET-SB", myPos: ["UTG","HIJ","CO","BTN"], filters: {
            potType: "5BET",
            lastRaiserPos: "SB",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    },
    {
        label: "vsBB", id: "1vs1-vs5BET-BB", myPos: ["UTG","HIJ","CO","BTN","SB"], filters: {
            potType: "5BET",
            lastRaiserPos: "BB",
            lastRaiseCalls: 0,
            oppsLeft: 1,
            deadCalls: 0,
            deadRaises: 0
        }
    }
];